// Verdrahtung der Anfrageformulare im Browser (Adressblock, Akustikbild-Block,
// Entwurf). Logik ohne Seitenbezug steht in anfrage-daten.js.
(() => {
  if (window.FennextAnfrageFormular) return;
  var D = window.FennextAnfrageDaten;
  var ENTWURF_MAX_MS = 60 * 60 * 1000;

  function feldwerte(container) {
    var werte = {};
    Array.prototype.forEach.call(container.querySelectorAll('[data-anfrage-feld]'), (el) => {
      var k = el.getAttribute('data-anfrage-feld');
      // :disabled erfasst auch Felder in einem gesperrten fieldset.
      if (el.disabled || el.matches(':disabled')) return;
      if (el.type === 'checkbox') werte[k] = el.checked;
      else if (el.type === 'radio') {
        if (el.checked) werte[k] = el.value;
      } else werte[k] = String(el.value || '').trim();
    });
    return werte;
  }

  function einsetzen(container, werte) {
    Array.prototype.forEach.call(container.querySelectorAll('[data-anfrage-feld]'), (el) => {
      var k = el.getAttribute('data-anfrage-feld');
      if (!(k in werte)) return;
      if (el.type === 'checkbox') el.checked = Boolean(werte[k]);
      else if (el.type === 'radio') el.checked = el.value === werte[k];
      else el.value = werte[k];
      el.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // Versteckte Felder muessen disabled sein — ein verstecktes required-Feld laesst
  // den Browser sonst stumm abbrechen (nicht fokussierbar).
  function bereichSchalten(el, an) {
    if (!el) return;
    el.hidden = !an;
    if (el.tagName === 'FIELDSET') el.disabled = !an;
    Array.prototype.forEach.call(el.querySelectorAll('input, select, textarea'), (f) => {
      f.disabled = !an;
    });
  }

  function pruefeFeld(feld, ok) {
    feld.setCustomValidity(ok ? '' : feld.getAttribute('data-fehler') || '');
  }

  function adresseVerdrahten(container) {
    var root = container.querySelector('[data-anfrage-adresse]');
    if (!root) return;
    var privat = root.querySelector('[data-anfrage-feld="customer.private"]');
    var land = root.querySelector('[data-land="billing"]');
    var liefer = root.querySelector('[data-anfrage-feld="shipping.different"]');
    var ust = root.querySelector('[data-anfrage-feld="billing.vat_id"]');

    // Laendernamen in der Seitensprache, Deutschland zuerst (anfrage-adresse.liquid liefert
    // nur Codes). Die Vorauswahl bleibt erhalten.
    var sprache = document.documentElement.lang || 'de';
    Array.prototype.forEach.call(root.querySelectorAll('select[data-land]'), (sel) => {
      var gewaehlt = sel.value;
      var codes = Array.prototype.map.call(sel.options, (o) => o.value);
      sel.textContent = '';
      D.laenderListe(codes, sprache).forEach((l) => {
        var o = document.createElement('option');
        o.value = l.code;
        o.textContent = l.name;
        if (l.code === gewaehlt) o.selected = true;
        sel.appendChild(o);
      });
    });

    function aktualisieren() {
      bereichSchalten(root.querySelector('[data-anfrage-firma]'), !privat.checked);
      bereichSchalten(
        root.querySelector('[data-anfrage-ust]'),
        !privat.checked && D.istEuAusland(land.value),
      );
      bereichSchalten(root.querySelector('[data-anfrage-liefer]'), liefer.checked);
      if (ust && !ust.disabled) pruefeFeld(ust, !ust.value || D.ustIdOk(land.value, ust.value));
      Array.prototype.forEach.call(root.querySelectorAll('[data-plz-fuer]'), (plz) => {
        var l = root.querySelector('[data-land="' + plz.getAttribute('data-plz-fuer') + '"]');
        if (!plz.disabled) pruefeFeld(plz, !plz.value || D.plzOk(l.value, plz.value));
      });
    }
    root.addEventListener('change', aktualisieren);
    root.addEventListener('input', aktualisieren);
    aktualisieren();
    return aktualisieren;
  }

  function entwurfSichern(schluessel, werte) {
    try {
      window.sessionStorage.setItem(
        schluessel,
        JSON.stringify({ ts: Date.now(), werte: D.entwurfOhneHerkunft(werte) }),
      );
    } catch (_e) {
      /* Speicher gesperrt: dann eben ohne Entwurf */
    }
  }

  function entwurfLaden(schluessel) {
    try {
      const roh = JSON.parse(window.sessionStorage.getItem(schluessel) || 'null');
      if (!roh || Date.now() - roh.ts > ENTWURF_MAX_MS) return null;
      return roh.werte;
    } catch (_e) {
      return null;
    }
  }

  function entwurfLoeschen(schluessel) {
    try {
      window.sessionStorage.removeItem(schluessel);
    } catch (_e) {
      /* egal */
    }
  }

  // Akustikbild-Angaben auf der Produktseite (snippets/pdp-akustik-angaben.liquid).
  // Liefert { aktualisieren, angaben, dateiLink, pruefen } fuer die Position der Seite.
  function akustikVerdrahten(container, regel, holeOptionen) {
    var root = container.querySelector('[data-anfrage-akustik]');
    if (!root) return null;
    var breite = root.querySelector('[data-anfrage-feld="akustik.width_cm"]');
    var hoehe = root.querySelector('[data-anfrage-feld="akustik.height_cm"]');
    var flaecheText = root.querySelector('[data-akustik-flaeche]');
    var datei = root.querySelector('[data-akustik-datei]');
    var sprache = document.documentElement.lang || 'de';

    function aktualisieren() {
      var optionen = holeOptionen() || [];
      var sonder = D.istSondergroesse(optionen);
      var format = D.formatAusOptionen(optionen);
      bereichSchalten(root.querySelector('[data-akustik-masse]'), sonder);
      bereichSchalten(
        root.querySelector('[data-akustik-ausrichtung]'),
        !sonder && !!format && format.breite_cm !== format.hoehe_cm,
      );
      bereichSchalten(datei, feldwerte(root)['akustik.motif'] !== 'suggestion');

      var ergebnis = sonder ? D.groessePruefen(breite.value, hoehe.value, regel) : 'ok';
      var f = sonder ? D.flaeche(breite.value, hoehe.value) : null;
      flaecheText.textContent = f
        ? root.getAttribute('data-text-flaeche').replace('@@F@@', f.toLocaleString(sprache))
        : '';
      // Werte, die keine Zahl ergeben ("2,5 m"), sperren das Absenden — sonst kaemen
      // Fläche und Conversion-Wert leer im Cockpit an.
      [breite, hoehe].forEach((feld) => {
        var n = D.zahl(feld.value);
        feld.setCustomValidity(feld.value && !(n > 0) ? root.getAttribute('data-text-zahl') : '');
      });
      if (ergebnis === 'zu_klein') {
        breite.setCustomValidity(
          root
            .getAttribute('data-text-zu-klein')
            .replace('@@M@@', regel.min_m2.toLocaleString(sprache)),
        );
      }

      root.querySelector('[data-akustik-uebergroesse]').hidden = ergebnis !== 'zu_gross';
    }

    // Vor dem Hinzufuegen zur Anfrage: ungueltige Pflichtfelder (Masse) melden.
    function pruefen() {
      aktualisieren();
      var felder = root.querySelectorAll('input:not(:disabled)');
      for (let i = 0; i < felder.length; i++) {
        if (!felder[i].checkValidity()) {
          felder[i].reportValidity();
          return false;
        }
      }
      return true;
    }

    function angaben() {
      return D.akustikAuswerten(feldwerte(root), holeOptionen() || [], regel);
    }

    function dateiLink() {
      // feldwerte laesst gesperrte Felder aus — bei Motivvorschlag also null.
      return feldwerte(root)['akustik.file_link'] || null;
    }

    root.addEventListener('input', aktualisieren);
    root.addEventListener('change', aktualisieren);
    document.addEventListener('fennext:variant', aktualisieren);
    aktualisieren();
    return {
      aktualisieren: aktualisieren,
      angaben: angaben,
      dateiLink: dateiLink,
      pruefen: pruefen,
    };
  }

  // Seitenformulare mit Mailtext (Beratung, Raumguide): Shopify haengt jedes benannte
  // contact[...]-Feld an die Mail, der Mailtext enthaelt dieselben Angaben schon — alles
  // kam doppelt (Grill 2026-10-28). Beim Absenden geht deshalb nur der Mailtext als
  // contact[body] ([data-mail-ziel]); Felder mit [data-in-mail] verlieren ihren Namen.
  // Name und E-Mail bleiben benannt: Shopify setzt daraus die Antwortadresse. Ohne JS
  // kommen die Einzelfelder wie bisher an. data-name-weg teilt sich die Rueckgabe nach
  // "Zurueck" (pageshow) mit leereFelderWeglassen in fennext.js.
  function inMailBuendeln(form, text) {
    buendelnZuruecknehmen(form);
    var ziel = form.querySelector('[data-mail-ziel]');
    if (!ziel) return;
    Array.prototype.forEach.call(form.querySelectorAll('[data-in-mail][name]'), (el) => {
      el.setAttribute('data-name-weg', el.name);
      el.removeAttribute('name');
    });
    ziel.value = text;
    ziel.name = 'contact[body]';
  }

  // Vor jedem erneuten Absenden und nach "Zurueck": Ausgangszustand, sonst stuende
  // contact[body] zweimal im Formular.
  function buendelnZuruecknehmen(form) {
    var ziel = form.querySelector('[data-mail-ziel]');
    if (ziel) ziel.removeAttribute('name');
    Array.prototype.forEach.call(form.querySelectorAll('[data-in-mail][data-name-weg]'), (el) => {
      el.name = el.getAttribute('data-name-weg');
      el.removeAttribute('data-name-weg');
    });
  }
  window.addEventListener('pageshow', () => {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mail-ziel]'), (ziel) => {
      if (ziel.form) buendelnZuruecknehmen(ziel.form);
    });
  });

  window.FennextAnfrageFormular = {
    inMailBuendeln: inMailBuendeln,
    feldwerte: feldwerte,
    einsetzen: einsetzen,
    bereichSchalten: bereichSchalten,
    adresseVerdrahten: adresseVerdrahten,
    entwurfSichern: entwurfSichern,
    entwurfLaden: entwurfLaden,
    akustikVerdrahten: akustikVerdrahten,
    entwurfLoeschen: entwurfLoeschen,
  };
})();
